import path from 'path';
import { mapGetters } from 'vuex';
import Logo from './Logo';
import SidebarItem from './SidebarItem';
function flattenSidebarRoutes(routes, parentPath = '') {
  if (!routes || !routes.length) return [];
  const res = [];
  const base = parentPath || '/';
  routes.forEach(route => {
    if (route.hidden) {
      if (route.children && route.children.length) {
        const nextBase = route.path === '/' || route.path === '' ? base : path.resolve(base, route.path);
        res.push(...flattenSidebarRoutes(route.children, nextBase));
      }
    } else {
      if (parentPath) {
        res.push({
          ...route,
          _sidebarParentPath: parentPath
        });
      } else {
        res.push(route);
      }
    }
  });
  return res;
}
export default {
  name: 'AppSidebar',
  components: {
    SidebarItem,
    Logo
  },
  computed: {
    ...mapGetters(['sidebar']),
    sidebarRoutes() {
      const raw = this.$store.getters['router/asyncRouters'] || [];
      return flattenSidebarRoutes(raw);
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    isCollapse() {
      return !this.sidebar.opened;
    }
  }
};